import { render, staticRenderFns } from "./jurnal.vue?vue&type=template&id=4a784d61&scoped=true"
import script from "./jurnal.vue?vue&type=script&lang=js"
export * from "./jurnal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a784d61",
  null
  
)

export default component.exports